"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useViewObserver = void 0;
const react_1 = require("react");
const observer_1 = require("./observer");
const preset_1 = require("./preset");
const useViewObserver = (props, deps = []) => {
    const { onView, ref: inputRef, options } = props;
    const ref = inputRef || (0, react_1.useRef)(null);
    const [tracked, setTracked] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const element = ref.current;
        if (!element || tracked) {
            return;
        }
        const observer = observer_1.ViewObserver.Factory.get(options || preset_1.ViewObserverPreset.default);
        observer.observe(element, (visible) => {
            if (visible) {
                onView();
                setTracked(true);
                observer.unobserve(element);
            }
        });
        return () => {
            observer.unobserve(element);
        };
    }, [ref, tracked, onView, ...deps]);
    return ref;
};
exports.useViewObserver = useViewObserver;
